<template>
  <div class="star-rating-component">
    <div class="d-flex align-items-center">
      <button
        type="button"
        v-for="(_, i) in ['', '', '', '', '']"
        :key="`star-${i}`"
        @click="submit"
        @mouseover="mouseover(i)"
        @mouseleave="mouseleave"
        class="btn btn-star m-0 p-0"
      >
        <i :class="rating >= i + 1 ? 'icon-filled-star' : 'icon-star'"></i>
      </button>
      <span class="ml-2 mr-2">Classifique</span>
      <b-spinner v-if="loading" variant="light" small></b-spinner>
    </div>
  </div>
</template>
<script>
import { clearObject } from "@/functions/helpers";
import get from "lodash/get";

export default {
  mounted() {
    this.dispatch();
  },
  data() {
    return {
      saved_rating: null,
      loading: false,
      rating: 0
    };
  },
  methods: {
    dispatch() {
      this.$store
        .dispatch("lessons/getRating", this.$route.params.lesson)
        .then(response => {
          this.saved_rating = response.data;
          this.rating = response.data.rating;
        });
    },
    mouseover(i) {
      this.rating = i + 1;
    },
    mouseleave() {
      this.rating = get(this.saved_rating, "rating", 0);
    },
    submit() {
      if (this.loading) return;

      const action = this.saved_rating
        ? "lessons/putRating"
        : "lessons/postRating";

      const payload = clearObject({
        id: get(this.saved_rating, "lesson_id", null),
        lesson_id: this.$route.params.lesson,
        rating: this.rating
      });

      this.loading = true;
      this.$store
        .dispatch(action, payload)
        .then(({ data }) => {
          this.saved_rating = data;
          this.rating = data.rating;
          this.$message.success("Obrigado por avaliar esta aula!");
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível salvar a sua avaliação da aula"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.star-rating-component {
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-left: -4px;
  .btn-star {
    color: #999;
    min-height: 24px;
    min-width: 24px;

    i {
      font-size: 20px;
      background: linear-gradient(
        33deg,
        #954ef8 1.67%,
        #d3568a 85.4%
      ) !important;
      background-clip: text !important;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .icon-filled-star {
      font-size: 18px;
    }
  }
}
</style>
